exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.highlight[data-v-70ce8938] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.highlight[data-v-70ce8938]:not(:last-of-type) {\n    margin-bottom: 15px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.highlight .value[data-v-70ce8938] {\n    font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-70ce8938","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/employees/learning/timeUsageSkills.vue
// module id = 578
// module chunks = 0